import * as React from "react";

import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
} from "@material-ui/core/styles";
import { Paper, PaperProps } from "@material-ui/core";

// Classes
import Utility from "../../domain/classes/Utility";

// NPM
import clsx from "clsx";
import { animated } from "react-spring";

export const styles = (theme: Theme) =>
	createStyles({ root: { padding: theme.spacing(1) } });

export interface OutlinedPaperWrapperProps extends PaperProps {}

const OutlinedPaperWrapper = React.forwardRef<
	HTMLDivElement,
	OutlinedPaperWrapperProps & WithStyles<typeof styles>
>(({ children, classes, className, ...paperProps }, ref) => {
	return (
		<Paper
			square
			elevation={0}
			variant="outlined"
			ref={ref}
			{...paperProps}
			className={clsx(classes.root, className)}
		>
			{children}
		</Paper>
	);
});

const StyledOutlinedPaperWrapper = withStyles(styles, {
	classNamePrefix: Utility.generateClassName("OutlinedPaperWrapper"),
})(OutlinedPaperWrapper);

export default StyledOutlinedPaperWrapper;

export const AnimatedOutlinedPaperWrapper = animated(
	StyledOutlinedPaperWrapper
);
